
const namespaced = true;

const state = {
  from: null,
  to: null,
  client: null,
  site: null,
  maker: null,
  interventions: [],
  sites: [],
  makers: [],
};

const mutations = {
  SET_FROM(state, from) {
    state.from = from;
  },
  SET_TO(state, to) {
    state.to = to;
  },
  SET_CLIENT(state, client) {
    state.client = client;
  },
  SET_SITE(state, site) {
    state.site = site;
  },
  SET_MAKER(state, maker) {
    state.maker = maker;
  },
  SET_INTERVENTIONS(state, interventions) {
    state.interventions = interventions;
  },
  SET_SITES(state, sites) {
    state.sites = sites;
  },
  SET_MAKERS(state, makers) {
    state.makers = makers;
  },
};

const actions = {
  async fetchInterventions({ dispatch, commit, state }) {
    const queryParams = {
      from: state.from,
      to: state.to,
      client: state.client,
      site: state.site,
      maker: state.maker,
    };
    const interventions = await dispatch(`model/intervention/fetchRawList`, { queryParams }, { root: true });

    commit(`SET_INTERVENTIONS`, interventions);
  },
  async fetchSites({ commit, dispatch, state }) {
    let sites = [];
    if (state.client) {
      sites = await dispatch(`model/site/fetchSitesForClient`, state.client, { root: true });
    }

    commit(`SET_SITES`, sites);
  },
  async fetchMakers({ commit, dispatch }) {
    const makers = await dispatch(`model/maker/fetchMakers`, null, { root: true });

    commit(`SET_MAKERS`, makers);
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
